import { VersionedAgentSchema } from "@redotech/redo-model/agents/versioned-agent";

import * as z from "zod/v4";

export const findAllLatestAgents = {
  name: "findAllLatestAgents" as const,
  input: z.object({}),
  output: z.array(VersionedAgentSchema),
};
